export default {
  20010: '发布失败，不存在签到表单',
  20012: '站点操作失败，员工已存在其他站点',
  20013: '站点操作失败，部门已存在其他站点',
  20014: '发布失败，不存在预约子表单',
  20015: '发布失败，不存在楼盘信息',
  20016: '站点操作失败，站点已存在',
  20017: '无编辑营销资料权限',
  20018: '海报尺寸信息已存在',
  20019: '海报用途信息已存在',
  20020: '含有海报尺寸的海报',
  20021: '含有海报用途的海报',
  20022: '您的文件夹数量已达上限，可删除部分呢文件夹之后继续添加',
  20023: '分组（分类）名重复了',
  20024: '素材库名称重复',
  20025: '同步营销素材报表太频繁',
  20026: '分组（分类）不存在',
  20027: '员工不存在',
  20028: '文件夹层级已达上限（10）',
  20029: '找不到素材库',
  20030: '没有删除权限',
  20031: '记录未找到',
  20032: '表单已审核,不能重复审核',
  20033: '当前层级文件夹数量已达上限（100）',
  20034: '请输入公众号链接',
  20041: '该文件夹下存在其他无权限查看的文件/文件夹，无法直接删除',
  20050: '手机号验证码错误',
  20051: '表单不存在或已删除',
  // 20052: '此表单不允许重复提交',
  20053: '导出表头与模型不匹配',
  20054: '文件名字为空',
  20055: '文件url为空',
  20056: '文件长度为0',
  20057: '普通素材id为空',
  20058: '商品id为空',
  20059: '内容id为空',
  20060: '名片id为空',
  20061: '活动id为空',
  20062: 'activity.type 活动类型不存在',
  20063: '名片小程序id为空',
  20064: '名片小程序路径为空',
  20065: '名片类型为空，card.type',
  20066: '名片userid或者名片qwUserID为空',
  20067: '小程序id为空',
  20068: '小程序path为空',
  200672: '小程序图片为空',
  20069: '任意链接地址为空',
  20070: '任意链接名字为空',
  20071: '更新操作实体id为空',
  20073: '媒体文件url, 主要特注图片、视频、文件等链接地址',
  30000: '参数不能为空',
  30001: '文件夹内包含不可见文件夹，暂不可删除',
  30002: '没有此数据',
  30003: 'Map中没有对应的数据',
  30004: 'Map中已经有对应的Key数据',
  30005: '没有该用户',
  30006: '缺少默认素材配置',
  30007: '创建渠道码ID错误',
  30008: '二维码正在被修改，请稍后再试',
  30009: '文件夹目录最多创建10层',
  30010: '请先清空文件夹内容后删除',
  30011: '定时发布时间不能小于当前时间',
  30012: '定时下架时间不能小于当前时间',
  30013: '没有画布数据',
  300014: '没有关联素材数据',
  30015: '该素材缺少渠道ID',
  30016: '没有开启海报二维码开关',
  30017: '该素材已经下架或已删除',
  30018: '素材状态为空',
  30019: '未开启员工二维码展示，请前往设置',
  2022325: '超过导出限制100人，请重新选择！',
  30060: '可见权限设置有误，请重新设置',
  30061: '父集合不存在',
  30062: '素材包type倒入错误，请检查接口约定',
  30063: '素材包内容type不存在，请检查接口约定',
  30064: '集合正在被修改，请稍后再试',
  30065: '文件夹已被删除',
  30066: '请选择文件夹',
  30067: '访问crystalApi失败',
  30068: '文件夹最多创建2000个',
  30069: '同层级文件夹最多创建50个'
} as any;
